import axiosClient from "./axiosClient";
import { API_ENDPOINTS, API_CREDENTIALS } from "./apiEndpoints";
import Cookies from "js-cookie";
const token = Cookies.get("token");

export const addAttendance = ({ AttendanceData }) =>
  axiosClient.post(
    API_ENDPOINTS.ADD_ATTENDANCE,
    {
      ...AttendanceData,
    },
    {
      headers: {
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        Accept: "application/json",
        "user-token": token,
        "Accept-Language": "en",
      },
    }
  );

export const updateAttendance = ({ AttendanceData }) =>
  axiosClient.post(
    API_ENDPOINTS.UPDATE_ATTENDANCE(),
    {
      ...AttendanceData,
    },
    {
      headers: {
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        Accept: "application/json",
        "user-token": token,
        "Accept-Language": "en",
      },
    }
  );
